export default __webpack_public_path__ + "static/media/ping-identity-logo.5ce88ba6.svg";